<app-header></app-header>
<div class="container">
    <div class="row">
        <div class="col-6">
            <h2>Alumnos</h2>
            <h5>Grupo: {{idGrupo}}  -   Tutor: {{tutor}}</h5>
        </div>
        <div class="col-6">
            <button class="btn btn-color2" (click)="volverAGrupo()">Volver</button>
        </div>
    </div>
    <div>
        <table *ngIf="expediente.length" class="table table-bordered table-striped table-hover" datatable [dtOptions]="dtOptions">
            <thead>
            <tr style="background-color: #002061; color: #eee;">
                <th>MATRICULA</th>
                <th>ALUMNO</th>
                <th>CARRERA</th>
                <th>SEMESTRE</th>
                <th>NO. DE SESIONES</th>
                <th style="width:15%">VER SESIONES</th>
                <th *ngIf="admin">SESIÓN INDIVIDUAL</th>
            </tr>
            </thead>
            <tbody>
                <tr *ngFor="let alumno of expediente">
                    <td>{{ alumno.matricula }}</td>
                    <td>{{ alumno.nombre }}</td>
                    <td>{{ alumno.carrera }}</td>
                    <td>{{ alumno.semestre }}</td>
                    <td>{{ alumno.numero_sesiones }}</td>
                    <td><button class="btn btn-color2" (click)="verSesion(alumno.matricula, alumno.nombre)">Ver sesiones <fa-icon [icon]="icon1"></fa-icon></button></td>
                    <td *ngIf="admin"><button class="btn btn-color3" (click)="registrar(alumno.matricula, alumno.nombre)">Registrar <fa-icon [icon]="icon2"></fa-icon></button></td>
                </tr>
            </tbody>
        </table>
        <h5 *ngIf="!expediente.length" style="color: rgb(102, 4, 4);">*No hay alumnos en el grupo</h5>
    </div>
</div>


<!-- <div id="comp-render" *ngIf="displayRegistroIndividual && !displayGrupo">
    <button class="btn btn-color2" (click)="volverAAlumnos()">Volver</button>
    
</div>

<div id="comp-render" *ngIf="displayGrupo && !displayRegistroIndividual">
    <app-grupos></app-grupos>
</div> -->